import { IDocument } from 'interfaces/document';
import { statuses } from 'interfaces/file';
import { IPaginationParams, IPaginationResponse } from 'interfaces/pagination';
import { Observable } from 'rxjs';
import apiService, { ApiService } from './api';

export class DocumentService {
  constructor(private apiService: ApiService) { }

  public list(params: IPaginationParams): Observable<IPaginationResponse<IDocument>> {
    return this.apiService.get('/document', params);
  }

  public listBy(
    params: IPaginationParams|IPaginationParams & { status?: statuses[], startDate: string, endDate: string },
    ventureId: number,
    entityId?: number
  ): Observable<IPaginationResponse<IDocument>> {
    const url = entityId
      ? `/document/venture/${ventureId}/${entityId}`
      : `/document/venture/${ventureId}`;

    return this.apiService.get(url, params);
  }

  public reorder(model: {
    id: number;
    upOrDown: '+' | '-'
  }): Observable<IDocument> {
    return this.apiService.post('/document/reorder', model);
  }

  public save(model: IDocument): Observable<IDocument> {
    return this.apiService.post('/document', model);
  }

  public saveMultipleDocs(model: IDocument): Observable<IDocument> {
    return this.apiService.post('/document/save', model);
  }

  public delete(id: number): Observable<void> {
    return this.apiService.delete(`/document/${id}`);
  }

  public deleteMultiple(documentsIds: number[]): Observable<void> {
    return this.apiService.post('/document/delete', { documentsIds });
  }
}

const documentService = new DocumentService(apiService);
export default documentService;